export function pickDataAttributes(
    props: Record<string, unknown>
): Record<string, string> {
    const dataAttributeMap: Record<string, string> = {}
    Object.entries(props).forEach(([key, value]) => {
        if (key.startsWith("data-") && typeof value === "string") {
            dataAttributeMap[key] = value
        }
    })
    return dataAttributeMap
}
